module.exports = `fragment inline_iframe on Contentstack_inline_frame {
    src
    height
  }`;